import { ClipboardEvent, RefObject } from 'react';

/**
 * usePasteEvent - handles pasting text or into selections
 * @param ref - A ref of either an textarea or an input
 */
const usePasteEvent = <R extends HTMLTextAreaElement | HTMLInputElement>(ref: RefObject<R>) => {
  /**
   * handlePaste - The event that handles pasting text
   * @param obj.event - The React ClipboardEvent
   */
  const handlePaste = <T,>({ event }: { event: ClipboardEvent<T> }) => {
    const existingText = ref.current?.value;
    const selectStart = ref.current?.selectionStart || 0;
    const selectEnd = ref.current?.selectionEnd || 0;
    const paste = event.clipboardData.getData('text');

    return (existingText?.substring(0, selectStart) || '') + paste + (existingText?.substring(selectEnd, existingText.length) || '');
  };

  return handlePaste;
};

export { usePasteEvent };
